
const mwl = module.exports = {};

/*******************************************************************
 * Form Inputs
 *******************************************************************/

/*
    .form-controls are animated with an underline during focus/blur
 */
mwl.attachFormControlUnderlining = function(rootEl) {
    var formControls = rootEl ? $(rootEl).find('.form-control') : $('.form-control');

    formControls.on('focus', function() {
        $(this).closest('.fg-line').addClass('fg-toggled');
    });
    formControls.on('blur', function() {
        $(this).closest('.fg-line').removeClass('fg-toggled');
    });
}

var uniqueTargetCounter = 0;
var reservedTargets = ['_blank', '_self', '_parent', '_top'];

/*
    Browsers reuse a same-named window/frame target across submissions, which cancels
    a still-in-flight submission (e.g. download) when another one reuses the same name.
    Appending a counter guarantees each caller gets its own target.
 */
mwl.uniqueTarget = function(base) {
    return base + '_' + (uniqueTargetCounter++);
}

/*
    create and post a form
 */
mwl.submitHiddenForm = function(action,params,method,target) {
    method = method || "POST";
    params = params || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", action);
    form.setAttribute("enctype", "application/json");
    if (target) {
        if (reservedTargets.indexOf(target) === -1) target = mwl.uniqueTarget(target);
        form.setAttribute("target",target);
    }

    // ADD CSRF TOKEN
    if (method.toUpperCase() !== "GET") {
        var csrf = document.querySelector('#csrf-token');
        if (csrf) csrf = csrf.getAttribute('content');
        if (csrf) params._token = csrf;
    }

    // ADD ALL OTHER INPUTS PROVIDED
    inputsFromJSON(form,params);

    document.body.appendChild(form);
    form.submit();

    /**************************************************************
     **************************************************************/
    function inputsFromJSON (form,params,baseName) {
        for (var key in params) {
            var name = (baseName) ? baseName + '[' + key + ']' : key;
            var value = params[key];
            var values = [];

            if (typeof(value) === 'object') {
                inputsFromJSON(form,value,name);
            }
            else if (Array.isArray(value)) {
                values = value;
                name += '[]';
            }
            else {
                values = [value];
            }

            for (var i=0;i<values.length;i++) {
                var val = values[i];
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", name);
                hiddenField.setAttribute("value", val);
                form.appendChild(hiddenField);
            }
        }
    }
}

/*******************************************************************
 * Modals/Widgets
 *******************************************************************/

/*
    Animates the sliding of a .slide-panel
 */
mwl.slidePanelTo = function(panel, slideNumber, animate) {
    var animationDuration = animate ? 300 : 0;

    var leftPadding = parseInt(panel.parent().css('padding-left').replace(/[^\d]/g,''));
    var rightPadding = parseInt(panel.parent().css('padding-right').replace(/[^\d]/g,''));

    var slideToShow = panel.children(':nth-child('+(slideNumber + 1)+')').css('visibility','visible');
    var leftSlide = slideToShow.prev();
    var rightSlide = slideToShow.next();

    var currentSlideNumber = panel.data('slide-panel-slide-number') || 0;

    //Slide to Show
    slideToShow.find('input[type=submit]').prop('disabled',false);
    panel.stop().animate({ left : (slideNumber * -100).toString() + '%' }, animationDuration, 'swing', function() {
        panel.data('slide-panel-slide-number',slideNumber);
        leftSlide.css('visibility','hidden');
        leftSlide.find('input[type=submit]').prop('disabled',true);
        rightSlide.css('visibility','hidden');
        rightSlide.find('input[type=submit]').prop('disabled',true);
    });
    slideToShow.css('visibility','visible');

    //Adjust Relative Positions
    var paddingOffset = 1.2;
    if (slideNumber < currentSlideNumber) {
        slideToShow.css('left', (leftPadding * -1 * paddingOffset).toString() + 'px');
        slideToShow.stop().animate({ left : 0 }, animationDuration, 'swing');

        rightSlide.stop().animate({ left : leftPadding * paddingOffset }, animationDuration, 'swing');
    }
    else if (slideNumber > currentSlideNumber) {
        slideToShow.css('left', leftPadding.toString() + 'px');
        slideToShow.stop().animate({ left : 0 }, animationDuration, 'swing');

        leftSlide.stop().animate({ left : leftPadding * -1 * paddingOffset }, animationDuration, 'swing');
    }
}


/*
    Attaches the necessary events to a slide panel to perform the sliding animation
 */
mwl.attachSlidePanelEvents = function(panel) {
    if (panel === undefined) panel = $('.slide-panel');
    if (panel.length == 0) return;

    var initialSlideNumber = panel.data('slide-panel-slide-number');
    if (!initialSlideNumber) initialSlideNumber = 0;
    mwl.slidePanelTo(panel,initialSlideNumber,false);

    panel.find('.slide-panel-move-left, .slide-panel-move-right').on('click', function() {
        var thisObj = $(this);
        var currentSlideNumber = panel.data('slide-panel-slide-number') || 0;
      if (thisObj.hasClass('slide-panel-move-left'))
      {
        var nextPanelNumber = currentSlideNumber - 1
      } else if (thisObj.hasClass('slide-panel-move-right'))
      {
        var nextPanelNumber = currentSlideNumber + 1
      }
        mwl.slidePanelTo(panel, nextPanelNumber, true);
    });
}

/*******************************************************************
 * Taxes
 * This objects handles retrieving tax information
 *******************************************************************/
mwl.tax = {
    /*
    items:
        array of objects => [{
                                id,
                                quantity,
                                taxCode,
                                unitPrice
                            }]
     address:
         object => {
             address1,
             address2,
             city,
             state_cd,
             country_cd,
             postal_cd
         }
     */
    getCollectible: function(items, accountNbr, shippingCost, address, success, error) {
        let params = {
            accountNumber: accountNbr,
            shippingCost: shippingCost,
            address: address,
            items: items
        };

        $.ajax({
            url: '/tax/collectible',
            data: params,
            method: 'POST',
            success: function(response) {
                if (typeof success === 'function') {
                    success(response.info, response.collectible);
                }
            },
            error: function(request,status,message) {
                if (typeof error === 'function') {
                    error(status,message);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mwllib.js